<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BgEQnY/tc-custom/FC-9781645367673.jpg?1684514558247?1705056298068" alt="This image is the cover for the book Magellan Point"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Magellan Point
      </h1>
      <p class="bookDescription body article font2">
        <p>Magellan Point is a novel about the lives of people living in the Western Pacific and their efforts to create political institutions that encompass many islands--efforts that resulted in states in Micronesia and the territory of the Northern Marianas Islands.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David T. Sanders
      </h2>
      
      <p class="authorDescription body article">David T. Sanders is a professional geologist and published author with worldwide experience. He writes his novels with themes based on those experiences.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b1ce6e6